// extracted by mini-css-extract-plugin
export default {"row":"MenuList_row__N34VG"};